export default __webpack_public_path__ + "static/media/gallery_07.891f50a2.jpg";